import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type IntegrationId = ID<"integration">;
export const integrationIdFormat = idFormat<IntegrationId>({ prefix: "intg_" });
